import { css } from '@emotion/react';
import { theme } from '../theme';
import { tokens } from '../tokens';
export const menuStaticStyle = css({
    maxHeight: 'unset',
});
export const destructiveItemStaticStyle = css({
    '&:hover': {
        backgroundColor: theme.error.transparent,
    },
    color: theme.error.text,
});
export const buttonStaticStyle = css({
    '&:not(:last-child)': {
        marginBottom: tokens.spacingNew.xsmall,
    },
    marginLeft: tokens.spacingNew.xsmall,
    marginRight: tokens.spacingNew.xsmall,
    width: 'calc(100% - 16px)',
});
export const notificationDotStaticStyle = css({
    backgroundColor: theme.error.main,
    borderRadius: tokens.borderRadius.circle,
    height: '6px',
    left: tokens.spacingNew.tiny,
    position: 'absolute',
    top: tokens.spacingNew.tiny,
    width: '6px',
    zIndex: tokens.zIndex.default,
});
